export default __webpack_public_path__ + "static/media/recent2.b1009182.jpg";